export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_MESSAGE_COUNTS_WORKORDER = 'SET_MESSAGE_COUNTS_WORKORDER'
export const SET_WORK_ORDER_MESSAGES = 'SET_WORK_ORDER_MESSAGES'
export const SET_ALL_MESSAGES = 'SET_ALL_MESSAGES'



// WEBPACK FOOTER //
// ./src/store/modules/messages/types.js